import React from 'react';
import './index.scss';

const action = (props) => {
    const {text, price, HandleSubmitOrder, disable} = props;

    console.log(disable)
    return (
        <div>

            <div className="art-order-detail__footer">
                <div>合计: <span>￥ {price}</span></div>

                {disable ?
                    <div style={{backgroundColor: "#888"}}>
                        {text}
                    </div>
                    :
                    <div
                        onClick={HandleSubmitOrder}>
                        {text}
                    </div>
                }


            </div>
        </div>
    )
}

export default action;